var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "slideInUp", delay: 0, duration: 300 },
          expression: "{ classes: 'slideInUp', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "chat-widget",
    },
    [
      _c("section", { staticClass: "header" }, [
        _c(
          "span",
          {
            staticClass: "material-icons text-info",
            staticStyle: { "font-size": "50px" },
          },
          [_vm._v(" chat ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-column" }, [
          _c(
            "strong",
            {
              staticClass: "font-weight-bold",
              staticStyle: { "font-size": "25px", "letter-spacing": "1.5px" },
            },
            [_vm._v(_vm._s(_vm.$t("Chatbot")))]
          ),
          _vm._v(" "),
          _c(
            "small",
            { staticClass: "text-success" },
            [
              _c("a-badge", { attrs: { color: "green" } }),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("chatbotv2.connected")) +
                  "\n            "
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c(
              "md-button",
              { staticClass: "md-icon-button" },
              [_c("md-icon", [_vm._v("more_vert")])],
              1
            ),
            _vm._v(" "),
            _c(
              "md-button",
              { staticClass: "md-icon-button", on: { click: _vm.closeWidget } },
              [_c("md-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "chat-conversation" }, [
        _c(
          "div",
          { staticClass: "conversation" },
          [
            _vm.getMessages().length
              ? _c("MessageList", {
                  attrs: {
                    "should-scroll": false,
                    "always-scroll-to-bottom": true,
                    colors: _vm.colors,
                    messages: _vm.getMessages(),
                    participants: _vm.participants,
                    "scroll-top": true,
                    "is-private-chat": true,
                    "show-chatbot-private": true,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "footer" }, [
        _c("input", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: false,
              expression: "false",
            },
          ],
          ref: "fileInput",
          attrs: { type: "file" },
          on: { change: _vm.onFileChange },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer-input-row" },
          [
            _c(
              "md-button",
              {
                staticClass: "md-icon-button md-dense footer-btn",
                attrs: {
                  disabled: _vm.closed || _vm.mediaUploadState.uploading,
                  title: _vm.$t("chatbotv2.sendFile"),
                },
                on: { click: _vm.triggerFileInput },
              },
              [
                _vm.mediaUploadState.uploading
                  ? _c("a-spin", { attrs: { size: "small" } })
                  : _c("md-icon", { staticStyle: { "font-size": "20px" } }, [
                      _vm._v("attach_file"),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "md-button",
              {
                staticClass: "md-icon-button md-dense footer-btn",
                class: { recording: _vm.voiceState.isRecording },
                attrs: {
                  disabled: _vm.closed || _vm.mediaUploadState.uploading,
                  title: _vm.$t("chatbotv2.voiceRecord"),
                },
                on: { click: _vm.toggleVoiceRecord },
              },
              [
                _vm.voiceState.isRecording
                  ? _c(
                      "span",
                      { staticClass: "mic-recording-icon" },
                      [
                        _c("span", { staticClass: "mic-pulse-ring" }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "mic-pulse-ring mic-pulse-ring--delay",
                        }),
                        _vm._v(" "),
                        _c(
                          "md-icon",
                          {
                            staticStyle: {
                              "font-size": "20px",
                              position: "relative",
                              "z-index": "1",
                            },
                          },
                          [_vm._v("stop")]
                        ),
                      ],
                      1
                    )
                  : _c("md-icon", { staticStyle: { "font-size": "20px" } }, [
                      _vm._v("mic"),
                    ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("UserInput", {
              attrs: {
                id: "privateChatUserInput",
                colors: _vm.colors,
                onSubmit: _vm.sendMessage,
                placeholder: _vm.$t("message.typeHere"),
                showEmoji: true,
                showFile: false,
                disabled:
                  _vm.closed ||
                  !_vm.$_.get(this.sezar, "userInputAllowed", true),
                "new-icon": true,
              },
              on: { onTyping: _vm.sendTyping },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.openMoment.visible
        ? _c("InFrame", {
            attrs: { url: _vm.openMoment.url, size: _vm.openMoment.size },
            on: {
              close: function ($event) {
                _vm.openMoment.visible = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }